const countries = [
	{
		id: 'AF',
		name: 'Afghanistan',
		region: 'Asia',
	},
	{
		id: 'AX',
		name: 'Åland Islands',
		region: 'Europe',
	},
	{
		id: 'AL',
		name: 'Albania',
		region: 'Europe',
	},
	{
		id: 'DZ',
		name: 'Algeria',
		region: 'Africa',
	},
	{
		id: 'AS',
		name: 'American Samoa',
		region: 'Oceania',
	},
	{
		id: 'AD',
		name: 'Andorra',
		region: 'Europe',
	},
	{
		id: 'AO',
		name: 'Angola',
		region: 'Africa',
	},
	{
		id: 'AI',
		name: 'Anguilla',
		region: 'Americas',
	},
	{
		id: 'AQ',
		name: 'Antarctica',
		region: '',
	},
	{
		id: 'AG',
		name: 'Antigua and Barbuda',
		region: 'Americas',
	},
	{
		id: 'AR',
		name: 'Argentina',
		region: 'Americas',
	},
	{
		id: 'AM',
		name: 'Armenia',
		region: 'Asia',
	},
	{
		id: 'AW',
		name: 'Aruba',
		region: 'Americas',
	},
	{
		id: 'AU',
		name: 'Australia',
		region: 'Oceania',
	},
	{
		id: 'AT',
		name: 'Austria',
		region: 'Europe',
	},
	{
		id: 'AZ',
		name: 'Azerbaijan',
		region: 'Asia',
	},
	{
		id: 'BS',
		name: 'Bahamas',
		region: 'Americas',
	},
	{
		id: 'BH',
		name: 'Bahrain',
		region: 'Asia',
	},
	{
		id: 'BD',
		name: 'Bangladesh',
		region: 'Asia',
	},
	{
		id: 'BB',
		name: 'Barbados',
		region: 'Americas',
	},
	{
		id: 'BY',
		name: 'Belarus',
		region: 'Europe',
	},
	{
		id: 'BE',
		name: 'Belgium',
		region: 'Europe',
	},
	{
		id: 'BZ',
		name: 'Belize',
		region: 'Americas',
	},
	{
		id: 'BJ',
		name: 'Benin',
		region: 'Africa',
	},
	{
		id: 'BM',
		name: 'Bermuda',
		region: 'Americas',
	},
	{
		id: 'BT',
		name: 'Bhutan',
		region: 'Asia',
	},
	{
		id: 'BO',
		name: 'Bolivia (Plurinational State of)',
		region: 'Americas',
	},
	{
		id: 'BQ',
		name: 'Bonaire, Sint Eustatius and Saba',
		region: 'Americas',
	},
	{
		id: 'BA',
		name: 'Bosnia and Herzegovina',
		region: 'Europe',
	},
	{
		id: 'BW',
		name: 'Botswana',
		region: 'Africa',
	},
	{
		id: 'BV',
		name: 'Bouvet Island',
		region: 'Americas',
	},
	{
		id: 'BR',
		name: 'Brazil',
		region: 'Americas',
	},
	{
		id: 'IO',
		name: 'British Indian Ocean Territory',
		region: 'Africa',
	},
	{
		id: 'BN',
		name: 'Brunei Darussalam',
		region: 'Asia',
	},
	{
		id: 'BG',
		name: 'Bulgaria',
		region: 'Europe',
	},
	{
		id: 'BF',
		name: 'Burkina Faso',
		region: 'Africa',
	},
	{
		id: 'BI',
		name: 'Burundi',
		region: 'Africa',
	},
	{
		id: 'CV',
		name: 'Cabo Verde',
		region: 'Africa',
	},
	{
		id: 'KH',
		name: 'Cambodia',
		region: 'Asia',
	},
	{
		id: 'CM',
		name: 'Cameroon',
		region: 'Africa',
	},
	{
		id: 'CA',
		name: 'Canada',
		region: 'Americas',
	},
	{
		id: 'KY',
		name: 'Cayman Islands',
		region: 'Americas',
	},
	{
		id: 'CF',
		name: 'Central African Republic',
		region: 'Africa',
	},
	{
		id: 'TD',
		name: 'Chad',
		region: 'Africa',
	},
	{
		id: 'CL',
		name: 'Chile',
		region: 'Americas',
	},
	{
		id: 'CN',
		name: 'China',
		region: 'Asia',
	},
	{
		id: 'CX',
		name: 'Christmas Island',
		region: 'Oceania',
	},
	{
		id: 'CC',
		name: 'Cocos (Keeling) Islands',
		region: 'Oceania',
	},
	{
		id: 'CO',
		name: 'Colombia',
		region: 'Americas',
	},
	{
		id: 'KM',
		name: 'Comoros',
		region: 'Africa',
	},
	{
		id: 'CG',
		name: 'Congo',
		region: 'Africa',
	},
	{
		id: 'CD',
		name: 'Congo, Democratic Republic of the',
		region: 'Africa',
	},
	{
		id: 'CK',
		name: 'Cook Islands',
		region: 'Oceania',
	},
	{
		id: 'CR',
		name: 'Costa Rica',
		region: 'Americas',
	},
	{
		id: 'CI',
		name: 'Côte d\'Ivoire',
		region: 'Africa',
	},
	{
		id: 'HR',
		name: 'Croatia',
		region: 'Europe',
	},
	{
		id: 'CU',
		name: 'Cuba',
		region: 'Americas',
	},
	{
		id: 'CW',
		name: 'Curaçao',
		region: 'Americas',
	},
	{
		id: 'CY',
		name: 'Cyprus',
		region: 'Asia',
	},
	{
		id: 'CZ',
		name: 'Czechia',
		region: 'Europe',
	},
	{
		id: 'DK',
		name: 'Denmark',
		region: 'Europe',
	},
	{
		id: 'DJ',
		name: 'Djibouti',
		region: 'Africa',
	},
	{
		id: 'DM',
		name: 'Dominica',
		region: 'Americas',
	},
	{
		id: 'DO',
		name: 'Dominican Republic',
		region: 'Americas',
	},
	{
		id: 'EC',
		name: 'Ecuador',
		region: 'Americas',
	},
	{
		id: 'EG',
		name: 'Egypt',
		region: 'Africa',
	},
	{
		id: 'SV',
		name: 'El Salvador',
		region: 'Americas',
	},
	{
		id: 'GQ',
		name: 'Equatorial Guinea',
		region: 'Africa',
	},
	{
		id: 'ER',
		name: 'Eritrea',
		region: 'Africa',
	},
	{
		id: 'EE',
		name: 'Estonia',
		region: 'Europe',
	},
	{
		id: 'SZ',
		name: 'Eswatini',
		region: 'Africa',
	},
	{
		id: 'ET',
		name: 'Ethiopia',
		region: 'Africa',
	},
	{
		id: 'FK',
		name: 'Falkland Islands (Malvinas)',
		region: 'Americas',
	},
	{
		id: 'FO',
		name: 'Faroe Islands',
		region: 'Europe',
	},
	{
		id: 'FJ',
		name: 'Fiji',
		region: 'Oceania',
	},
	{
		id: 'FI',
		name: 'Finland',
		region: 'Europe',
	},
	{
		id: 'FR',
		name: 'France',
		region: 'Europe',
	},
	{
		id: 'GF',
		name: 'French Guiana',
		region: 'Americas',
	},
	{
		id: 'PF',
		name: 'French Polynesia',
		region: 'Oceania',
	},
	{
		id: 'TF',
		name: 'French Southern Territories',
		region: 'Africa',
	},
	{
		id: 'GA',
		name: 'Gabon',
		region: 'Africa',
	},
	{
		id: 'GM',
		name: 'Gambia',
		region: 'Africa',
	},
	{
		id: 'GE',
		name: 'Georgia',
		region: 'Asia',
	},
	{
		id: 'DE',
		name: 'Germany',
		region: 'Europe',
	},
	{
		id: 'GH',
		name: 'Ghana',
		region: 'Africa',
	},
	{
		id: 'GI',
		name: 'Gibraltar',
		region: 'Europe',
	},
	{
		id: 'GR',
		name: 'Greece',
		region: 'Europe',
	},
	{
		id: 'GL',
		name: 'Greenland',
		region: 'Americas',
	},
	{
		id: 'GD',
		name: 'Grenada',
		region: 'Americas',
	},
	{
		id: 'GP',
		name: 'Guadeloupe',
		region: 'Americas',
	},
	{
		id: 'GU',
		name: 'Guam',
		region: 'Oceania',
	},
	{
		id: 'GT',
		name: 'Guatemala',
		region: 'Americas',
	},
	{
		id: 'GG',
		name: 'Guernsey',
		region: 'Europe',
	},
	{
		id: 'GN',
		name: 'Guinea',
		region: 'Africa',
	},
	{
		id: 'GW',
		name: 'Guinea-Bissau',
		region: 'Africa',
	},
	{
		id: 'GY',
		name: 'Guyana',
		region: 'Americas',
	},
	{
		id: 'HT',
		name: 'Haiti',
		region: 'Americas',
	},
	{
		id: 'HM',
		name: 'Heard Island and McDonald Islands',
		region: 'Oceania',
	},
	{
		id: 'VA',
		name: 'Holy See',
		region: 'Europe',
	},
	{
		id: 'HN',
		name: 'Honduras',
		region: 'Americas',
	},
	{
		id: 'HK',
		name: 'Hong Kong',
		region: 'Asia',
	},
	{
		id: 'HU',
		name: 'Hungary',
		region: 'Europe',
	},
	{
		id: 'IS',
		name: 'Iceland',
		region: 'Europe',
	},
	{
		id: 'IN',
		name: 'India',
		region: 'Asia',
	},
	{
		id: 'ID',
		name: 'Indonesia',
		region: 'Asia',
	},
	{
		id: 'IR',
		name: 'Iran (Islamic Republic of)',
		region: 'Asia',
	},
	{
		id: 'IQ',
		name: 'Iraq',
		region: 'Asia',
	},
	{
		id: 'IE',
		name: 'Ireland',
		region: 'Europe',
	},
	{
		id: 'IM',
		name: 'Isle of Man',
		region: 'Europe',
	},
	{
		id: 'IL',
		name: 'Israel',
		region: 'Asia',
	},
	{
		id: 'IT',
		name: 'Italy',
		region: 'Europe',
	},
	{
		id: 'JM',
		name: 'Jamaica',
		region: 'Americas',
	},
	{
		id: 'JP',
		name: 'Japan',
		region: 'Asia',
	},
	{
		id: 'JE',
		name: 'Jersey',
		region: 'Europe',
	},
	{
		id: 'JO',
		name: 'Jordan',
		region: 'Asia',
	},
	{
		id: 'KZ',
		name: 'Kazakhstan',
		region: 'Asia',
	},
	{
		id: 'KE',
		name: 'Kenya',
		region: 'Africa',
	},
	{
		id: 'KI',
		name: 'Kiribati',
		region: 'Oceania',
	},
	{
		id: 'KP',
		name: 'Korea (Democratic People\'s Republic of)',
		region: 'Asia',
	},
	{
		id: 'KR',
		name: 'Korea, Republic of',
		region: 'Asia',
	},
	{
		id: 'KW',
		name: 'Kuwait',
		region: 'Asia',
	},
	{
		id: 'KG',
		name: 'Kyrgyzstan',
		region: 'Asia',
	},
	{
		id: 'LA',
		name: 'Lao People\'s Democratic Republic',
		region: 'Asia',
	},
	{
		id: 'LV',
		name: 'Latvia',
		region: 'Europe',
	},
	{
		id: 'LB',
		name: 'Lebanon',
		region: 'Asia',
	},
	{
		id: 'LS',
		name: 'Lesotho',
		region: 'Africa',
	},
	{
		id: 'LR',
		name: 'Liberia',
		region: 'Africa',
	},
	{
		id: 'LY',
		name: 'Libya',
		region: 'Africa',
	},
	{
		id: 'LI',
		name: 'Liechtenstein',
		region: 'Europe',
	},
	{
		id: 'LT',
		name: 'Lithuania',
		region: 'Europe',
	},
	{
		id: 'LU',
		name: 'Luxembourg',
		region: 'Europe',
	},
	{
		id: 'MO',
		name: 'Macao',
		region: 'Asia',
	},
	{
		id: 'MG',
		name: 'Madagascar',
		region: 'Africa',
	},
	{
		id: 'MW',
		name: 'Malawi',
		region: 'Africa',
	},
	{
		id: 'MY',
		name: 'Malaysia',
		region: 'Asia',
	},
	{
		id: 'MV',
		name: 'Maldives',
		region: 'Asia',
	},
	{
		id: 'ML',
		name: 'Mali',
		region: 'Africa',
	},
	{
		id: 'MT',
		name: 'Malta',
		region: 'Europe',
	},
	{
		id: 'MH',
		name: 'Marshall Islands',
		region: 'Oceania',
	},
	{
		id: 'MQ',
		name: 'Martinique',
		region: 'Americas',
	},
	{
		id: 'MR',
		name: 'Mauritania',
		region: 'Africa',
	},
	{
		id: 'MU',
		name: 'Mauritius',
		region: 'Africa',
	},
	{
		id: 'YT',
		name: 'Mayotte',
		region: 'Africa',
	},
	{
		id: 'MX',
		name: 'Mexico',
		region: 'Americas',
	},
	{
		id: 'FM',
		name: 'Micronesia (Federated States of)',
		region: 'Oceania',
	},
	{
		id: 'MD',
		name: 'Moldova, Republic of',
		region: 'Europe',
	},
	{
		id: 'MC',
		name: 'Monaco',
		region: 'Europe',
	},
	{
		id: 'MN',
		name: 'Mongolia',
		region: 'Asia',
	},
	{
		id: 'ME',
		name: 'Montenegro',
		region: 'Europe',
	},
	{
		id: 'MS',
		name: 'Montserrat',
		region: 'Americas',
	},
	{
		id: 'MA',
		name: 'Morocco',
		region: 'Africa',
	},
	{
		id: 'MZ',
		name: 'Mozambique',
		region: 'Africa',
	},
	{
		id: 'MM',
		name: 'Myanmar',
		region: 'Asia',
	},
	{
		id: 'NA',
		name: 'Namibia',
		region: 'Africa',
	},
	{
		id: 'NR',
		name: 'Nauru',
		region: 'Oceania',
	},
	{
		id: 'NP',
		name: 'Nepal',
		region: 'Asia',
	},
	{
		id: 'NL',
		name: 'Netherlands',
		region: 'Europe',
	},
	{
		id: 'NC',
		name: 'New Caledonia',
		region: 'Oceania',
	},
	{
		id: 'NZ',
		name: 'New Zealand',
		region: 'Oceania',
	},
	{
		id: 'NI',
		name: 'Nicaragua',
		region: 'Americas',
	},
	{
		id: 'NE',
		name: 'Niger',
		region: 'Africa',
	},
	{
		id: 'NG',
		name: 'Nigeria',
		region: 'Africa',
	},
	{
		id: 'NU',
		name: 'Niue',
		region: 'Oceania',
	},
	{
		id: 'NF',
		name: 'Norfolk Island',
		region: 'Oceania',
	},
	{
		id: 'MK',
		name: 'North Macedonia',
		region: 'Europe',
	},
	{
		id: 'MP',
		name: 'Northern Mariana Islands',
		region: 'Oceania',
	},
	{
		id: 'NO',
		name: 'Norway',
		region: 'Europe',
	},
	{
		id: 'OM',
		name: 'Oman',
		region: 'Asia',
	},
	{
		id: 'PK',
		name: 'Pakistan',
		region: 'Asia',
	},
	{
		id: 'PW',
		name: 'Palau',
		region: 'Oceania',
	},
	{
		id: 'PS',
		name: 'Palestine, State of',
		region: 'Asia',
	},
	{
		id: 'PA',
		name: 'Panama',
		region: 'Americas',
	},
	{
		id: 'PG',
		name: 'Papua New Guinea',
		region: 'Oceania',
	},
	{
		id: 'PY',
		name: 'Paraguay',
		region: 'Americas',
	},
	{
		id: 'PE',
		name: 'Peru',
		region: 'Americas',
	},
	{
		id: 'PH',
		name: 'Philippines',
		region: 'Asia',
	},
	{
		id: 'PN',
		name: 'Pitcairn',
		region: 'Oceania',
	},
	{
		id: 'PL',
		name: 'Poland',
		region: 'Europe',
	},
	{
		id: 'PT',
		name: 'Portugal',
		region: 'Europe',
	},
	{
		id: 'PR',
		name: 'Puerto Rico',
		region: 'Americas',
	},
	{
		id: 'QA',
		name: 'Qatar',
		region: 'Asia',
	},
	{
		id: 'RE',
		name: 'Réunion',
		region: 'Africa',
	},
	{
		id: 'RO',
		name: 'Romania',
		region: 'Europe',
	},
	{
		id: 'RU',
		name: 'Russian Federation',
		region: 'Europe',
	},
	{
		id: 'RW',
		name: 'Rwanda',
		region: 'Africa',
	},
	{
		id: 'BL',
		name: 'Saint Barthélemy',
		region: 'Americas',
	},
	{
		id: 'SH',
		name: 'Saint Helena, Ascension and Tristan da Cunha',
		region: 'Africa',
	},
	{
		id: 'KN',
		name: 'Saint Kitts and Nevis',
		region: 'Americas',
	},
	{
		id: 'LC',
		name: 'Saint Lucia',
		region: 'Americas',
	},
	{
		id: 'MF',
		name: 'Saint Martin (French part)',
		region: 'Americas',
	},
	{
		id: 'PM',
		name: 'Saint Pierre and Miquelon',
		region: 'Americas',
	},
	{
		id: 'VC',
		name: 'Saint Vincent and the Grenadines',
		region: 'Americas',
	},
	{
		id: 'WS',
		name: 'Samoa',
		region: 'Oceania',
	},
	{
		id: 'SM',
		name: 'San Marino',
		region: 'Europe',
	},
	{
		id: 'ST',
		name: 'Sao Tome and Principe',
		region: 'Africa',
	},
	{
		id: 'SA',
		name: 'Saudi Arabia',
		region: 'Asia',
	},
	{
		id: 'SN',
		name: 'Senegal',
		region: 'Africa',
	},
	{
		id: 'RS',
		name: 'Serbia',
		region: 'Europe',
	},
	{
		id: 'SC',
		name: 'Seychelles',
		region: 'Africa',
	},
	{
		id: 'SL',
		name: 'Sierra Leone',
		region: 'Africa',
	},
	{
		id: 'SG',
		name: 'Singapore',
		region: 'Asia',
	},
	{
		id: 'SX',
		name: 'Sint Maarten (Dutch part)',
		region: 'Americas',
	},
	{
		id: 'SK',
		name: 'Slovakia',
		region: 'Europe',
	},
	{
		id: 'SI',
		name: 'Slovenia',
		region: 'Europe',
	},
	{
		id: 'SB',
		name: 'Solomon Islands',
		region: 'Oceania',
	},
	{
		id: 'SO',
		name: 'Somalia',
		region: 'Africa',
	},
	{
		id: 'ZA',
		name: 'South Africa',
		region: 'Africa',
	},
	{
		id: 'GS',
		name: 'South Georgia and the South Sandwich Islands',
		region: 'Americas',
	},
	{
		id: 'SS',
		name: 'South Sudan',
		region: 'Africa',
	},
	{
		id: 'ES',
		name: 'Spain',
		region: 'Europe',
	},
	{
		id: 'LK',
		name: 'Sri Lanka',
		region: 'Asia',
	},
	{
		id: 'SD',
		name: 'Sudan',
		region: 'Africa',
	},
	{
		id: 'SR',
		name: 'Suriname',
		region: 'Americas',
	},
	{
		id: 'SJ',
		name: 'Svalbard and Jan Mayen',
		region: 'Europe',
	},
	{
		id: 'SE',
		name: 'Sweden',
		region: 'Europe',
	},
	{
		id: 'CH',
		name: 'Switzerland',
		region: 'Europe',
	},
	{
		id: 'SY',
		name: 'Syrian Arab Republic',
		region: 'Asia',
	},
	{
		id: 'TW',
		name: 'Taiwan, Province of China',
		region: 'Asia',
	},
	{
		id: 'TJ',
		name: 'Tajikistan',
		region: 'Asia',
	},
	{
		id: 'TZ',
		name: 'Tanzania, United Republic of',
		region: 'Africa',
	},
	{
		id: 'TH',
		name: 'Thailand',
		region: 'Asia',
	},
	{
		id: 'TL',
		name: 'Timor-Leste',
		region: 'Asia',
	},
	{
		id: 'TG',
		name: 'Togo',
		region: 'Africa',
	},
	{
		id: 'TK',
		name: 'Tokelau',
		region: 'Oceania',
	},
	{
		id: 'TO',
		name: 'Tonga',
		region: 'Oceania',
	},
	{
		id: 'TT',
		name: 'Trinidad and Tobago',
		region: 'Americas',
	},
	{
		id: 'TN',
		name: 'Tunisia',
		region: 'Africa',
	},
	{
		id: 'TR',
		name: 'Turkey',
		region: 'Asia',
	},
	{
		id: 'TM',
		name: 'Turkmenistan',
		region: 'Asia',
	},
	{
		id: 'TC',
		name: 'Turks and Caicos Islands',
		region: 'Americas',
	},
	{
		id: 'TV',
		name: 'Tuvalu',
		region: 'Oceania',
	},
	{
		id: 'UG',
		name: 'Uganda',
		region: 'Africa',
	},
	{
		id: 'UA',
		name: 'Ukraine',
		region: 'Europe',
	},
	{
		id: 'AE',
		name: 'United Arab Emirates',
		region: 'Asia',
	},
	{
		id: 'GB',
		name: 'United Kingdom of Great Britain and Northern Ireland',
		region: 'Europe',
	},
	{
		id: 'US',
		name: 'United States of America',
		region: 'Americas',
	},
	{
		id: 'UM',
		name: 'United States Minor Outlying Islands',
		region: 'Oceania',
	},
	{
		id: 'UY',
		name: 'Uruguay',
		region: 'Americas',
	},
	{
		id: 'UZ',
		name: 'Uzbekistan',
		region: 'Asia',
	},
	{
		id: 'VU',
		name: 'Vanuatu',
		region: 'Oceania',
	},
	{
		id: 'VE',
		name: 'Venezuela (Bolivarian Republic of)',
		region: 'Americas',
	},
	{
		id: 'VN',
		name: 'Viet Nam',
		region: 'Asia',
	},
	{
		id: 'VG',
		name: 'Virgin Islands (British)',
		region: 'Americas',
	},
	{
		id: 'VI',
		name: 'Virgin Islands (U.S.)',
		region: 'Americas',
	},
	{
		id: 'WF',
		name: 'Wallis and Futuna',
		region: 'Oceania',
	},
	{
		id: 'EH',
		name: 'Western Sahara',
		region: 'Africa',
	},
	{
		id: 'YE',
		name: 'Yemen',
		region: 'Asia',
	},
	{
		id: 'ZM',
		name: 'Zambia',
		region: 'Africa',
	},
	{
		id: 'ZW',
		name: 'Zimbabwe',
		region: 'Africa',
	},
];

const countriesEUMain = [
	...countries.filter(c => c.region === 'Europe'),
	...countries.filter(c => c.region !== 'Europe').map(c => ({ ...c, region: '' })),
];

const eerCountries = ['AT', 'BE', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LI', 'LT', 'LU', 'LV', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];

const isEerCountry = (countryCode) => eerCountries.includes(countryCode);

export {
	countries,
	countriesEUMain,
	eerCountries,
	isEerCountry,
};